import request from '@/utils/request'

// 查询社区小组详情列表
export function listCommunityGroupDetail(query) {
  return request({
    url: '/biz/admin/community/community/group/detail/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区小组详情分页
export function pageCommunityGroupDetail(query) {
  return request({
    url: '/biz/admin/community/community/group/detail/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区小组详情详细
export function getCommunityGroupDetail(data) {
  return request({
    url: '/biz/admin/community/community/group/detail/detail',
    method: 'get',
    params: data
  })
}

// 新增社区小组详情
export function addCommunityGroupDetail(data) {
  return request({
    url: '/biz/admin/community/community/group/detail/add',
    method: 'post',
    data: data
  })
}

// 修改社区小组详情
export function updateCommunityGroupDetail(data) {
  return request({
    url: '/biz/admin/community/community/group/detail/edit',
    method: 'post',
    data: data
  })
}

// 删除社区小组详情
export function delCommunityGroupDetail(data) {
  return request({
    url: '/biz/admin/community/community/group/detail/delete',
    method: 'post',
    data: data
  })
}
